import * as React from 'react';
import TwitterCard from '../../Card/TwitterCard';

import peeringLogo from './peeringIcon-logo.svg';
import { Tweet } from '../../../GraphQL';

interface TwitterFeedProps {
  twitterFeed: Tweet[];
}

const TwitterFeed: React.SFC<TwitterFeedProps> = ({ twitterFeed }) => (
  <>
    {twitterFeed.map((tweet, index) => (
      <TwitterCard
        icon={peeringLogo}
        key={index}
        postedAt={tweet.postedAt}
        author={tweet.author}
        body={tweet.body}
        bubble={index % 2 === 0 ? 'left' : 'right'}
        className="my-4"
      />
    ))}
  </>
);

export default TwitterFeed;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/Twitter/TwitterFeed.tsx